'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
//context
var TRANSLATION_CONTEXT = exports.TRANSLATION_CONTEXT = 'quickdeposit';

// actions
var action = 'QD_ACTION_';
var QD_ACTION_OPEN_RECEIVED = exports.QD_ACTION_OPEN_RECEIVED = action + 'OPEN_RECEIVED';
var QD_ACTION_CONFIG_RECEIVED = exports.QD_ACTION_CONFIG_RECEIVED = action + 'CONFIG_RECEIVED';
var QD_ACTION_CLOSED = exports.QD_ACTION_CLOSED = action + 'CLOSED';
var QD_ACTION_CLOSING = exports.QD_ACTION_CLOSING = action + 'CLOSING';
var QD_ACTION_FETCH_PMT_METHODS = exports.QD_ACTION_FETCH_PMT_METHODS = action + 'FETCH_PMT_METHODS';
var QD_ACTION_FETCH_PMT_METHODS_SUCCEDED = exports.QD_ACTION_FETCH_PMT_METHODS_SUCCEDED = action + 'FETCH_PMT_METHODS_SUCCEDED';
var QD_ACTION_FETCH_PMT_METHODS_FAILED = exports.QD_ACTION_FETCH_PMT_METHODS_FAILED = action + 'FETCH_PMT_METHODS_FAILED';
var QD_ACTION_PERFORM_DEPOSIT = exports.QD_ACTION_PERFORM_DEPOSIT = action + 'PERFORM_DEPOSIT';
var QD_ACTION_PERFORM_DEPOSIT_SUCCEDED = exports.QD_ACTION_PERFORM_DEPOSIT_SUCCEDED = action + 'PERFORM_DEPOSIT_SUCCEDED';
var QD_ACTION_PERFORM_APAY_DEPOSIT_SUCCEDED = exports.QD_ACTION_PERFORM_APAY_DEPOSIT_SUCCEDED = action + 'PERFORM_APAY_DEPOSIT_SUCCEDED';
var QD_ACTION_PERFORM_DEPOSIT_FAILED = exports.QD_ACTION_PERFORM_DEPOSIT_FAILED = action + 'PERFORM_DEPOSIT_FAILED';
var QD_ACTION_RESTART_DEPOSIT = exports.QD_ACTION_RESTART_DEPOSIT = action + 'RESTART_DEPOSIT';
var QD_ACTION_INIT3DS = exports.QD_ACTION_INIT3DS = action + 'INIT3DS';
var QD_ACTION_INIT3DS_V2 = exports.QD_ACTION_INIT3DS_V2 = action + 'INIT3DS_V2';
var QD_ACTION_COMPLETE3DS = exports.QD_ACTION_COMPLETE3DS = action + 'COMPLETE3DS';
var QD_ACTION_OPEN_STANDARD_DEPOSIT = exports.QD_ACTION_OPEN_STANDARD_DEPOSIT = action + 'OPEN_STANDARD_DEPOSIT';
var QD_ACTION_TRACKING_EVENT = exports.QD_ACTION_TRACKING_EVENT = action + 'TRACKING_EVENT';
var QD_ACTION_SET_IS_APPLE_PAY_AVAILABLE = exports.QD_ACTION_SET_IS_APPLE_PAY_AVAILABLE = action + 'SET_IS_APPLE_PAY_AVAILABLE';
var QD_ACTION_UPDATE_INIT_DATA = exports.QD_ACTION_UPDATE_INIT_DATA = action + 'UPDATE_INIT_DATA';
var QD_ACTION_SET_PLAYER_AMOUNT = exports.QD_ACTION_SET_PLAYER_AMOUNT = action + 'SET_PLAYER_AMOUNT';

// component internal statuses
var status = 'status.';
var QD_STATUS_INACTIVE = exports.QD_STATUS_INACTIVE = status + 'inactive';
var QD_STATUS_ACTIVE = exports.QD_STATUS_ACTIVE = status + 'active';
var QD_STATUS_INITIALIZING = exports.QD_STATUS_INITIALIZING = status + 'initializing';
var QD_STATUS_PMT_SUBMITTING = exports.QD_STATUS_PMT_SUBMITTING = status + 'pmt_submitting';
var QD_STATUS_PMT_SUCCEDED = exports.QD_STATUS_PMT_SUCCEDED = status + 'pmt_succeded';
var QD_STATUS_PMT_FAILED = exports.QD_STATUS_PMT_FAILED = status + 'pmt_failed';
var QD_STATUS_3DS = exports.QD_STATUS_3DS = status + '3ds';
var QD_STATUS_3DS_V2 = exports.QD_STATUS_3DS_V2 = status + '3dsV2';
var QD_STATUS_CLOSING = exports.QD_STATUS_CLOSING = status + 'closing';
var QD_STATUS_CLOSED = exports.QD_STATUS_CLOSED = status + 'closed';
var QD_STATUS_FAILED = exports.QD_STATUS_FAILED = status + 'failed';

var QD_3DS_V2 = exports.QD_3DS_V2 = '3dsV2';

// OB API status
var OB_PMT_API_STATUS_AWAITING3DS = exports.OB_PMT_API_STATUS_AWAITING3DS = 'awaiting3DS';
var OB_PMT_API_STATUS_AWAITING3DS_V2 = exports.OB_PMT_API_STATUS_AWAITING3DS_V2 = 'awaiting3DSv2';
var OB_PMT_API_STATUS_SUCCESS = exports.OB_PMT_API_STATUS_SUCCESS = 'SUCCESS';
var OB_PMT_API_STATUS_ERROR = exports.OB_PMT_API_STATUS_ERROR = 'ERROR';
var OB_PMT_API_STATUS_CHALLENGE_REQUIRED = exports.OB_PMT_API_STATUS_CHALLENGE_REQUIRED = 'CHALLENGE_REQUIRED';

// REDUX-FORM constants
var QD_RF_FORM_NAME = exports.QD_RF_FORM_NAME = 'quickDepositForm-' + Date.now();
var QD_RF_FIELD_AMOUNT = exports.QD_RF_FIELD_AMOUNT = 'amount';
var QD_RF_FIELD_CVV = exports.QD_RF_FIELD_CVV = 'cvv';
var QD_RF_FIELD_CARDID = exports.QD_RF_FIELD_CARDID = 'cardId';
var QD_RF_FIELD_EXPIRY_DATE = exports.QD_RF_FIELD_EXPIRY_DATE = 'expiry_date';

// Default values
var QD_DEFAULT_LAYOUT = exports.QD_DEFAULT_LAYOUT = 'vertical';

// business requirements
var REQUIRED_MINIMUM_TIME_FOR_DISPLAYING_SPINNER_MS = exports.REQUIRED_MINIMUM_TIME_FOR_DISPLAYING_SPINNER_MS = 2000;

// message bus topics:
var TRACKING_TOPIC_EVENT_PARTIAL = exports.TRACKING_TOPIC_EVENT_PARTIAL = 'wh.common.command.dli.tl.eventPartial';

// errors for displaying message:
var QD_ERRORS_CODES = exports.QD_ERRORS_CODES = ['MB_FS_DEP5', 'SB_FS_DEP5', 'MB_FS_BLONG5', 'SB_FS_BLONG5', 'MB_FS_BLONG2', 'MB_FS_DEP3', 'SB_FS_DEP3', 'ERR_FS_TIMEOUT'];